import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class OverrideTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private version: string,
    private prefix = './../assets/i18n/',
    private suffix = '.json',
  ) {}

  public getTranslation(lang: string) {
    const baseUrl = `${this.prefix}${lang}${this.suffix}?v=${this.version}`;
    const overrideUrl = `${this.prefix}${lang}.override${this.suffix}?v=${this.version}`;

    // Load base language
    const base$ = this.http.get<Record<string, any>>(baseUrl);

    // Try to load override.json, but catch 404 and return {}
    const override$ = this.http.get<Record<string, any>>(overrideUrl).pipe(
      catchError(() => of({})), // ignore missing override
    );

    return forkJoin([base$, override$]).pipe(
      map(([base, override]) => this.deepMerge(base, override)),
    );
  }

  private deepMerge(base: any, override: any): any {
    for (const key in override) {
      if (override.hasOwnProperty(key)) {
        if (typeof override[key] === 'object' && base[key]) {
          base[key] = this.deepMerge(base[key], override[key]);
        } else {
          base[key] = override[key];
        }
      }
    }
    return base;
  }
}
